import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppInsightsService } from "@api/services/app-insights/app-insights.service";
import { SessionStorageService } from "@shared/services/session-storage.service";
import { SessionStorageKeys } from "@shared/services/static/session-storage-keys";

// NOTE - BS - this component handles navigations to the postLogoutUrl (users click the 'Return to Login' link
//             on the identity server's logout page)
@Component({
    selector: "app-signout-callback-component",
    template: "<p>Loading...</p>",
    standalone: true,
})
export class SignoutCallbackComponent implements OnInit {
    private readonly router: Router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly sessionStorage = inject(SessionStorageService);
    private readonly appInsightsService = inject(AppInsightsService);

    ngOnInit(): void {
        const stateParam = this.activatedRoute.snapshot.queryParamMap.get("state");
        const storedState = this.sessionStorage.getItem(SessionStorageKeys.PostLogoutState);

        this.sessionStorage.removeItem(SessionStorageKeys.PostLogoutState);

        if (!stateParam || stateParam !== storedState) {
            this.appInsightsService.logTrace("State mismatch on signout callback");
            this.router.navigate(["/unexpected-error"]);
            return;
        }

        this.sessionStorage.clearAcwState();
        this.router.navigate(["/"]);
    }
}
